import cookies from 'js-cookie';

export const TOKEN_KEY = 'pay-Token';

export const setCookie = (tokenKey, token) => {
  if (token.length > 4000) {
    const tokens = token.match(/.{1,4000}/g);
    const data = [];

    for (let i = 0; i < tokens.length; i++) {
      let token = tokens[i];
      let key = `${tokenKey}-${i}`;

      cookies.set(key, token);

      if (cookies.get(key) !== undefined) {
        data.push(key);
      }
    }

    cookies.set(tokenKey, data.join('|'));
  } else {
    cookies.set(tokenKey, token);
  }
};

export const getCookie = tokenKey => {
  const cookie = cookies.get(tokenKey);

  if (cookie !== undefined) {
    if (cookie.startsWith(`${tokenKey}-`)) {
      const keys = cookie.split('|');

      const tokens = keys.map(key => {
        return cookies.get(key);
      });

      return tokens.join('');
    } else {
      return cookie;
    }
  } else {
    return null;
  }
};

export const removeCookie = tokenKey => {
  const cookie = cookies.get(tokenKey);

  if (cookie !== undefined) {
    if (cookie.startsWith(`${tokenKey}-`)) {
      const keys = cookie.split('|');

      keys.map(key => {
        cookies.remove(key);
        return true;
      });
    }

    cookies.remove(tokenKey);
  }
};

export const isAuthenticated = () => getToken(TOKEN_KEY) !== null;

export const getToken = () =>
  getCookie(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);

export const login = (token, remember) => {
  remember
    ? localStorage.setItem(TOKEN_KEY, token)
    : setCookie(TOKEN_KEY, token);
};

export const logout = () => {
  removeCookie(TOKEN_KEY);
  localStorage.clear();
};
